import { z } from 'zod';
import { PASSWORD_MIN_LENGTH } from '@/shared/config/password';


export const resetPasswordSchema = z.object({
    password: z.string()
        .min(PASSWORD_MIN_LENGTH, `Password must be at least ${ PASSWORD_MIN_LENGTH } characters`)
        .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
        .regex(/[0-9]/, 'Password must contain at least one number')
        .regex(/^[A-Za-z0-9!@#$%^&*]*$/, 'Password contains invalid characters'),
});

export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;
